module.exports = __webpack_public_path__ + "static/img/img9.20bc70b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img9.jpg
// module id = 1Qex
// module chunks = 0